import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column text-center" },
    [
      _c("span", { staticClass: "text-overline ma-8" }, [
        _vm._v(
          _vm._s(_vm.$vuetify.lang.t("$vuetify.worksheet.chooseLocation"))
        ),
      ]),
      _c(VAutocomplete, {
        attrs: {
          label: _vm.$vuetify.lang.t("$vuetify.worksheet.location"),
          placeholder: "Choose a location for inventory",
          items: _vm.filteredLocations,
          "item-text": "name",
          "item-value": "id",
          clearable: "",
          solo: "",
          "hide-details": "",
        },
        model: {
          value: _vm.locationId,
          callback: function ($$v) {
            _vm.locationId = $$v
          },
          expression: "locationId",
        },
      }),
      _c(
        "div",
        { staticClass: "d-flex justify-center mx-2 my-8" },
        [
          _c(
            VBtn,
            {
              attrs: {
                disabled: _vm.worksheet.status == "USED",
                color: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.updateWorksheet(_vm.worksheet)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }